import React, { useState } from "react";

const Transactions: React.FC = () => {
  // Dummy data for transactions
  const transactions = [
    { id: 1, amount: 500, status: "Pending", date: "2024-03-25", buyer: "UserA", seller: "UserB" },
    { id: 2, amount: 1200, status: "Completed", date: "2024-03-20", buyer: "UserB", seller: "UserA" },
  ];

  const [filter, setFilter] = useState<"Bought" | "Sold">("Bought");

  // Get logged-in user (replace with actual user ID)
  const loggedInUser = "UserA";

  // Filter transactions based on selected filter
  const filteredTransactions = transactions.filter((txn) =>
    filter === "Bought" ? txn.buyer === loggedInUser : txn.seller === loggedInUser
  );

  return (
    <div className="container mx-auto p-4 sm:p-6">
      {/* Title */}
      <h1 className="text-2xl font-semibold mb-4 text-center sm:text-left">Transactions</h1>

      {/* Filter Buttons */}
      <div className="flex flex-col sm:flex-row sm:space-x-4 mb-4">
        <button
          className={`px-4 py-2 rounded-md w-full sm:w-auto ${filter === "Bought" ? "bg-blue-500 text-white" : "bg-gray-200 text-black"}`}
          onClick={() => setFilter("Bought")}
        >
          Bought
        </button>
        <button
          className={`px-4 py-2 rounded-md w-full sm:w-auto mt-2 sm:mt-0 ${filter === "Sold" ? "bg-blue-500 text-white" : "bg-gray-200 text-black"}`}
          onClick={() => setFilter("Sold")}
        >
          Sold
        </button>
      </div>

      {/* Escrow Balance */}
      <div className="bg-white shadow-md rounded-lg p-4">
        <h2 className="text-gray-700 text-xl font-semibold mb-3">Escrow Balance: <span className="text-green-600">₹5,000</span></h2>

        {/* Responsive Table Wrapper */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100 text-gray-700 text-sm">
                <th className="p-2 text-left">Transaction ID</th>
                <th className="p-2 text-left">Amount</th>
                <th className="p-2 text-left">Status</th>
                <th className="p-2 text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredTransactions.length > 0 ? (
                filteredTransactions.map((txn) => (
                  <tr key={txn.id} className="border-b text-gray-700 text-sm">
                    <td className="p-2">{txn.id}</td>
                    <td className="p-2">₹{txn.amount} (INR)</td>
                    <td className={`p-2 font-semibold ${txn.status === "Completed" ? "text-green-600" : "text-yellow-500"}`}>
                      {txn.status}
                    </td>
                    <td className="p-2">{txn.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="p-4 text-center text-gray-500">No transactions found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
